import { MARKETING_SMS_CONSENT_V3 } from '@opendoor/auth-fe/forms';

import type { OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput } from '../../__generated__/athena/graphql';
import { OdProtosCustomerV1Data_PreferenceSource } from '../../__generated__/athena/graphql';

// Consent copy + version live in auth-fe (`consent/smsConsentVersions.tsx`) so
// the recorded `consentLanguage` matches the exact copy shown. The login form is in cosmos, so changes here
// originate from the cosmos preference source.
const PREFERENCE_SOURCE = OdProtosCustomerV1Data_PreferenceSource.PREFERENCE_SOURCE_COSMOS;

export const LOGIN_SMS_CONSENT = MARKETING_SMS_CONSENT_V3;

/**
 * Builds the comm-preference payload for the sign-up (account-creation) path.
 * Only brand-new customers go through this form — a returning customer with
 * existing preferences lands on the login path, which has no consent checkbox —
 * so there's no prior marketing opt-in to preserve. A new customer's stored
 * preference defaults to marketing opted IN (CreateDefaultCommPreference leaves
 * the opt-out timestamp null), so the checkbox state must be written explicitly:
 *   - preference-driving checkbox checked   -> marketingSmsOptOut: false (opted in)
 *   - preference-driving checkbox unchecked -> marketingSmsOptOut: true (opted out)
 * Account/service checkboxes without drivesPreference are display-only for now.
 */
export function buildLoginSmsConsentInput(
  customerUuid: string,
  subscribed: boolean,
): OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput {
  return {
    customerUuid,
    consentLanguage: LOGIN_SMS_CONSENT.version,
    preferenceSource: PREFERENCE_SOURCE,
    marketingSmsOptOut: !subscribed,
  };
}
